import axios from 'axios';
import { IModelHSystemParameter } from '@/shared/model/model-h-system-parameter.model';

const baseApiUrl = 'api/model-h-system-parameters';

export default class ModelHSystemParameterService {
  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IModelHSystemParameter): Promise<IModelHSystemParameter> {
    return new Promise<IModelHSystemParameter>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public reset(parameterId: number): Promise<IModelHSystemParameter> {
    return new Promise<IModelHSystemParameter>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/reset/${parameterId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
